module.exports = __webpack_public_path__ + "media/images/application/template/flag-aus-e483eea80e835831503a81b9c736778f.png";